import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { loginActions } from './action/loginAction';
import { withTranslation } from 'react-i18next';
import { alertActions } from './action/AlertAction';
import Header from './Header/Header';
import { Helmet } from "react-helmet";
import AllCountries from './Pages/Home/Nationality.json';
import { history } from './helpers/history';
import Footer from './Footer/Footer';
import { appVariables } from './helpers/appVariables';
// const countryLst = [{ id: 0, name: "Select Nationality" }, { id: 1, name: "India" }, { id: 2, name: "UAE" }, { id: 3, name: "Ban" }, { id: 4, name: "Philippines" }]
// const countryLst = [{ id: 0, name: "Select Nationality" }, { id: 1, name: "India" }, { id: 2, name: "UAE" }, { id: 3, name: "Qatar" }, { id: 4, name: "Oman" }]
const countryLst = AllCountries.Nationality;  // 177 Countries Loaded 
class RegisterThankYou extends Component {
    constructor(props) {
        const queryParameters = new URLSearchParams(window.location.search);
        const _type = queryParameters.get("flag");
        super(props);
        this.state = {
            Flag: _type,
            Coupencode: localStorage.getItem('coupencode') ? JSON.parse(localStorage.getItem('coupencode')) : ""
        }
    }


    showMsg = (msg) => { this.props.alertError(this.props.t(msg)); }

    render() {
        const { t } = this.props;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket - Register Activation</title>
                    <meta name="description" content="Securely Access Your Gulf Ticket Account: Register Now" />
                    <meta name="keywords" content="Gulf Ticket, online raffle draw, Biggest Online Draw" />

                    <meta property="og:title" content="Gulf Ticket - Register Activation" />
                    <meta property="og:site_name" content="Gulf Ticket" />
                    <meta property="og:url" content="https://gulfticket.com" />
                    <meta property="og:description" content="Securely Access Your Gulf Ticket Account: Register Now" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                </Helmet>}
                <Header />
                {this.state.Flag == appVariables.OTP.Register ? <div className="subContainer">
                    <div class="pasContainer">
                        <span class="checkImg"><img src="./assets/img/Check.png" /></span>
                        <h3>{t('lblthankyou')}</h3>
                        <small>{t('lblthankyoumsg')}</small>
                        {this.state.Coupencode.length > 0 && <p>CoupenCode : {this.state.Coupencode.replaceAll('|',',')}</p>}
                        <a onClick={() => { history.push('/login') }}>{t('lblloginnow')}</a>
                    </div>
                </div> : <div className="subContainer">
                    <div class="pasContainer">
                        <span class="checkImg"><img src="./assets/img/Check.png" /></span>
                        <h3>Password Reset Confirmed</h3>
                        <small>Your password has been successfully changed.</small>
                        <a onClick={() => { history.push('/login') }}>{t('lblloginnow')}</a>
                    </div>
                </div>}
                <Footer />
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, otp } = state.loginReducer;
    return { user, otp };
}
const mapActionToProps = {
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(RegisterThankYou))